export const CONTACT_ID_PARAM_NAME = 'contactId' as const
